<template>
	<div class="wrapper">
		<div class="content-container">
			<div class="operate-container">
				  <div class="opreate-item" @click="setTopicUp(data.id, '0')">
					  <el-badge :value="data.likeNum" type="info" :hidden="data.likeNum == 0 ? true : false">
						<i class="iconfont icon-dianzan_kuai"></i>
					  </el-badge>
				  </div>
				  <div class="opreate-item" @click="toComment">
					  <el-badge :value="data.commentNum" type="info" :hidden="data.commentNum == 0 ? true : false">
						<i class="iconfont icon-pinglun"></i>
					  </el-badge>
				  </div>
				<div class="opreate-item" @click="data.isCollect?cancleTopicCollect():setTopicCollect()">
					<i class="iconfont icon-shoucang" :class="{'iscollect': data.isCollect == 1}"></i>
				</div>
				<div class="opreate-item" @click="setTopicForward">
					<i class="iconfont icon-zhuanfa"></i>
				</div>
				<div class="opreate-item">
					<i class="iconfont icon-jinggao-F"></i>
				</div>
			</div>
			<div class="detail-container">
				<div class="news-container">
					<div class="title">{{data.title}}</div>
					<div class="tagList">
						<span class="tag" v-for="item in data.tagArray">{{item.tagName}}</span>
					</div>
					<div class="publisher">
						<div class="headIcon" v-if="data.postUserInfo">
							<el-image :src="data.postUserInfo.avatar">
								<div slot="error" class="image-slot">
									<el-image :src="require('@/assets/header.png')" fit="fill"></el-image>
								</div>
							</el-image>
							<span>{{data.postUserInfo.nickname}}</span>
						</div>
						<div class="createDate" v-if="data.createDate">发布于：{{data.createDate?data.createDate.slice(0,19):''}}</div>
						<div class="readNum">浏览量：{{data.readNum>1000?data.readNum>10000?(data.readNum/10000).toFixed(1)+'w':(data.readNum/1000).toFixed(1)+'k':data.readNum}}</div>
					</div>
					<!-- <div class="abstrc">{{data.description}}</div> -->
					<div class="body" v-html="data.body"></div>
					<div style="font-size: 15px;margin-top: 15px;">版权声明：本文由【欢软平台】平台创作，标题:{{data.title}}、图片来自网络，如涉及侵权，请及时与我们联系，我们会立即删除或修改侵权内容。谢谢！！</div>
				</div>
				<div class="commit-wrapper" id="comment">
					<div class="title">全部评论<span class="totalNum">（{{commitTotal}}）</span></div>
					
					<div class="input-wrapper">
						<Emotion ref="EmotionB" :topicId="data.id" @returnRes="getCommit(data.id)"></Emotion>
						<!-- <el-button  class="publish-btn" type="warning" size="medium" @click="publish()">发布</el-button> -->
					</div>
					
					<div class="commit-item" v-for="(item,index) in commitList" :style="{'display':index>=5 && isCollapsed?'none':'block'}">
						<div class="headIcon">
							<el-image :src="item.sendUserAvatar" >
								<div slot="error" class="image-slot">
								  <el-image :src="require('@/assets/header.png')" fit="fill"></el-image>
								</div>
							</el-image>
						</div>
						<div  class="content">
							<div class="commit-user">
								<div class="username">{{item.sendUserNickName }}</div>
								<span class="sendDate" v-if="item.sendDate">{{item.sendDate.slice(0,19)}}</span>
							</div>
							<div class="commit-content" v-html="item.sendContent"></div>
							<div class="operate">
								<div  @click="setTopicUp(item.id, '1')"><i class="iconfont icon-dianzan"></i><span>{{item.likeNum?item.likeNum:'点赞'}}</span></div>
								<div @click="replyComment(item)"><i class="iconfont icon-31pinglun"></i><span>{{item.replyList&&item.replyList.length>0?item.replyList.length:'回复'}}</span></div>
							</div>
							<div class="shuru" :style="{'display': item.showInput?'block':'none'}">
								<div class="input-wrapper">
									<Emotion ref="EmotionB" :topicId="data.id" :placeholder="'回复 '+item.sendUserNickName" :data="item" @returnRes="getCommit(data.id)"></Emotion>
									<!-- <el-button  class="publish-btn" type="warning" size="medium" @click="publish(item)">发布</el-button> -->
								</div>
							</div>
							<div class="reply" v-if="item.replyList.length>0">
								<div class="reply-item" v-for="(val,i) in item.replyList" :style="{'display':i>=2 && hideReply?'none':'block'}">
									<div class="headIcon">
										<el-image :src="val.sendUserAvatar" >
											<div slot="error" class="image-slot">
											  <el-image :src="require('@/assets/header.png')" fit="fill"></el-image>
											</div>
										</el-image>
									</div>
									<div class="reply-content">
										<div class="publish-msg">
											<span>{{val.sendUserNickName }}</span>
											<span>回复</span>
											<span>{{val.replyUserNickName}}: </span>
											<span v-html="val.sendContent"></span>
										</div>
										<div class="operate">
											<div v-if="val.sendDate">{{val.sendDate.slice(0,19)}}</div>
											<div @click="setTopicUp(val.id, '1')"><i class="iconfont icon-dianzan"></i><span>{{val.likeNum?val.likeNum:'点赞'}}</span></div>
											<div @click="replyComment(val)"><i class="iconfont icon-31pinglun"></i><span>回复</span></div>
										</div>
										<div class="shuru" :style="{'display': val.showInput?'block':'none'}">
											<div class="input-wrapper">
												<Emotion ref="EmotionB" :topicId="data.id" :placeholder="'回复 '+val.sendUserNickName" :data="val" @returnRes="getCommit(data.id)"></Emotion>
												<!-- <el-button  class="publish-btn" type="warning" size="medium" @click="publish(val)">发布</el-button> -->
											</div>
										</div>
									</div>
								</div>
								<div class="showAllitem" v-if="item.replyList.length>2 && hideReply" @click="hideReply = false">
									查看全部{{item.replyList.length}}条回复 <i class="icons el-icon-arrow-down"></i>
								</div>
							</div>
						</div>
					</div>
					<div class="showAll" v-if="commitList.length>5 && isCollapsed" @click="isCollapsed = false">
						展开全部{{commitTotal}}条评论 <i class="icons el-icon-arrow-down"></i>
					</div>
				</div>
				
			</div>
			<div class="sidebar">
				<div class="side-item">
					<div class="title">热门话题 <span class="btn" :class="{'change-btn':ischange}" @click="toggleChange" v-if="topicList.length>5"><i class="el-icon-refresh-right"></i>换一换</span></div>
					<div class="topic" v-for="(item,index) in topicList" :style="{'display':isToggle?index>=5 ?'none':'block':index<5 ?'none':'block'}">
						<span class="num" :class="{'top1':index==0,'top2':index==1,'top3':index==2}">{{index+1}}</span>
						<span class="topic-title" @click="todetail(item.id)">{{item.title}}</span>
					</div>	
				</div>
				<div class="side-item">
					<div class="title">热门标签</div>
					<div class="tagList">
						<span class="tag" v-for="val in tagArray" @click="$router.push({name:'social',params:{typeId:'',tagId:val.id}})">{{val.tagName}}</span>
					</div>	
				</div>
				<div class="side-item">
					<div class="title">公众号</div>
					<el-image class="qrcode" :src="require('@/assets/qrcode.jpg')" fit="contain"></el-image>
					<div class="tips">关注微信公众号，订阅每周资讯</div>
				</div>
				<div class="active-image">
					<el-image :src="require('@/assets/activity-image.png')" fit="contain">
						<div slot="error" class="image-slot">
							<i class="el-icon-picture-outline"></i>
						</div>
					</el-image>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getDetail,getCommitList,publishCommit,topicUp,topicCollect,cancleCollect,gethotTopic,hotTag } from '@/api/social/index'
import { toLogin } from '@/api/isLogin'
import { getIsTrial, getToken } from '@/utils/auth'
import VueUeditorWrap from 'vue-ueditor-wrap'
import Emotion from '@/components/Emotion'
import emotions from '@/utils/emoji.js'
export default {
	components:{
	  Emotion
	},
  metaInfo(){
	return {
		title: this.title,
		meta:[{
			name:'description',
			content: this.data.seoDescription
		},{
			name:'keywords',
			content: this.data.seoKeyword
		}]
	}  
  },
  data () {
    return {
       data: {},
	   title: '',
	   commitList:[],
	   commitTotal: 0,
	   isCollapsed: true,
	   hideReply: true,
	   ischange:false,
	   isToggle: true,
	   comment: '',
	   myConfig: {
	     serverUrl: '',
	     UEDITOR_HOME_URL: '/UEditor/'
	   },
	   emptyValue:false,
	   topicList:[],
	   EmotionList:[],
	   commitComment: ''
    }
  },
  methods: {
	toComment(){
		this.$nextTick(()=>{
			let target = document.getElementById('comment')
			document.documentElement.scrollTop = target.offsetTop
		})
	},
	async getHotTag(){
		const res = await hotTag()
		if (res.code === 0) {
			this.tagArray = res.data
		} else {
		  this.$message.error(res.msg)
		}
	},
    async getData(id){
    	const res = await getDetail(id)
    	if (res.code === 0) {
			if(res.data.title.indexOf('欢软平台') == -1){
				this.title = res.data.title + '-欢软平台'
			}else{
				this.title = res.data.title
			}
    		this.data = res.data
    	} else {
    	  this.$message.error(res.msg)
    	}
    },
	async getCommit(id){
		const res = await getCommitList({topicId:id})
		if (res.code === 0) {
			res.data.list.forEach((item)=>{
				item.showInput = false
				item.replyList.forEach((val)=>{
					val.showInput = false
				})
			})
			this.commitList = res.data.list
			this.commitTotal = res.data.total
		} else {
		  this.$message.error(res.msg)
		}
	},
	async hotTopic(){
		const res = await gethotTopic()
		if (res.code === 0) {
			this.topicList = res.data
		} else {
		  this.$message.error(res.msg)
		}
	},
	todetail(id){
		this.getData(id)
		this.getCommit(id)
		this.$router.push({path:'/social/detail/'+id})
	},
	/* async publish(item){
		if(getToken()){
			this.emptyValue = true
			
			const res = await publishCommit({
				"isComment": item?"0":'1',
				"isReply": item?"1":'0',
				"sendContent": this.comment,
				"replyUser": item?item.sendUser:'',
				"topicId": this.data.id,
				"parentId": item?item.parentId=='0'?item.id:item.parentId:'0',
			})
			if (res.code === 0) {
				this.comment = ''
				if(item){
					item.showInput = false
					this.$message.success('已成功回复')
				}else{
					this.$message.success('已成功发表评论')
				}
				this.getCommit(this.data.id)
			} else {
			  this.$message.error(res.msg)
			}
		}else{
			toLogin(this)
		}
		
	}, */
	replyComment(item){
		if(getToken()){
			item.showInput = !item.showInput
		}else{
			toLogin(this)
		}
	},
	toggleChange(){
		this.ischange = true
		this.isToggle = !this.isToggle
		setTimeout(() => {
		  this.ischange = false;
		}, 500); 
	},
	async setTopicUp(id,type){
		if(getToken()){
			const res = await topicUp({dataId:id,type:type})
			if (res.code === 0) {
				 this.$message({
				  message: res.msg,
				  type: 'success'
				});
				this.getData(this.data.id)
				this.getCommit(this.data.id)
			} else {
			  this.$message.error(res.msg)
			}
		}else{
			toLogin(this)
		}
		
	},
	async setTopicCollect(){
		if(getToken()){
			const res = await topicCollect({dataId:this.data.id,type:'0'})
			if (res.code === 0) {
				 this.$message({
				  message: res.msg,
				  type: 'success'
				});
				this.getData(this.data.id)
			} else {
			  this.$message.error(res.msg)
			}
		}else{
			toLogin(this)
		}
		
	},
	async cancleTopicCollect(){
		if(getToken()){
			const res = await cancleCollect({dataId:this.data.id})
			if (res.code === 0) {
				 this.$message({
				  message: '已取消收藏',
				  type: 'success'
				});
				this.getData(this.data.id)
			} else {
			  this.$message.error(res.msg)
			}
		}else{
			toLogin(this)
		}
		
	},
	setTopicForward(){  // 转发
		
	}
  },
  mounted () {
    var id = this.$route.params.id
	this.getData(id)
	this.getCommit(id)
	window.scrollTo({top:0})
	this.hotTopic()
	this.getHotTag()
	this.EmotionList = emotions.emotionList
  }

}
</script>

<style lang="scss" scoped>
.wrapper{
	background-color: #F9FAFD;
	width: 100vw;
	padding-top: 20px;
	margin: 80px auto 0;
	.publisher{
		color: #A1A7B0;
		font-size: 14px;
		&>div{
			display: inline-block;
			margin-right: 20px;
		}
	}
	.headIcon{
		margin-right: 10px;
		.el-image{
			width: 26px;
			height: 26px;
			border-radius:50%;
		}
	}
}
.content-container{
	max-width: 1400px;
	width: 85vw;
	margin: auto;
}
.operate-container{
	display: inline-block;
	vertical-align: top;
	margin-right: 50px;
	padding-top: 50px;
	.opreate-item{
		width: 50px;
		height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #fff;
		border-radius: 50%;
		margin-bottom: 20px;
		cursor: pointer;
		/deep/.el-badge__content.is-fixed{
			top: -5px;
			right: -5px;
			background-color: #C0C0CD;
		}
		.iconfont{
			color: #79797C;
			font-size: 20px;
			
		}
		.iscollect{
			color: #FFA653;
		}
	}
}
.detail-container{
	display: inline-block;
	width: calc(100% - 400px);
}
.news-container{
	
	padding: 20px 50px;
	text-align: left;
	background-color: #fff;
	border-radius: 10px;
	/deep/ img{
		width: 100%;
	}
	.title{
		font-size: 26px;
		font-weight: 800;
		margin: 10px 0;
		color: #262932;
	}
	.tagList{
		margin: 10px 0;
		.tag{
			background-color: #F1F6FD;
			margin-right: 10px;
			padding: 2px 8px;
			border-radius: 3px;
			color: #5989ee;
			font-size: 14px;
		}
	}
	.createDate{
		font-size: 14px;
		color: #A1A7B0;
		margin-bottom: 10px;
	}
	.abstrc{
		margin: 20px 0;
	}	
}
.commit-wrapper{
	margin: 20px 0;
	padding: 20px 50px;
	text-align: left;
	background-color: #fff;
	border-radius: 10px;
	
	.title{
		font-size: 22px;
		font-weight: 800;
		color: #000000;
		margin: 10px auto 20px;
		.totalNum{
			font-size: 16px;
			font-weight: 500;
			color: #B0AAA1;
			margin-left: 10px;
		}
	}
	.input-wrapper{
		margin-bottom: 20px;
	}
	.publish-btn{
		margin-top: -25px;
		float: right;
		background-color: #FF842E;
	}
	.commit-item{
		border-top: 1px solid #D9D8D9;
		padding: 15px 0;
		.reply{
			background-color: #F8F9FA;
			border-radius: 20px;
			padding: 20px 30px;
			margin-top: 10px;
		}
		.shuru{
			margin-top: 10px;
		}
		.headIcon,.content,.reply-content{
			display: inline-block;
			vertical-align: text-top;
		}
		.content{
			width: calc(100% - 36px);
			/deep/ p{
				margin: 0;
				padding: 0;
				color: #20232B;
				img{
					vertical-align: bottom;
				}
			}
			.username{
				display: inline-block;
				margin-right: 30px;
			}
			.sendDate{
				color: #A1A7B0;
				font-size: 14px;
			}
			.commit-content{
				margin-top: 5px;
			}
			.commit-user{
				font-size: 16px;
			}
			.reply-content{
				color: #404450;
				width: calc(100% - 36px);
				.publish-msg>span{
					display: inline-block;
					margin-right: 8px;
					&:last-child{
						margin: 0;
						
					}
				}
			}
		}
	}
	.showAllitem{
		color: #A1A7B0;
		font-size: 14px;
		margin: 5px 36px;
		&:hover{
			cursor: pointer;
		}
	}
	.showAll{
		color: #A1A7B0;
		font-size: 14px;
		background-color: #F8F9FA;
		border-radius: 20px;
		padding: 20px;
		text-align: center;
		&:hover{
			cursor: pointer;
		}
	}
	.icons{
		margin-left: 10px;
	}
	.operate{
		margin-top: 5px;
		&>div{
			display: inline-block;
			margin-right: 30px;
			color: #A1A7B0;
			font-size: 14px;
			cursor: pointer;
			&:hover{
				opacity: .8;
			}
			.iconfont{
				margin-right: 10px;
				font-size: 16px;
			}
		}
	}
}
.sidebar{
	display: inline-block;
	vertical-align: top;
	.active-image{
		.el-image{
			width: 270px;
			margin: 0 0 30px 30px;
		}
	}
	.side-item{
		width: 270px;
		box-sizing: border-box;
		padding: 24px;
		margin: 0 0 30px 30px;
		border-radius: 15px;
		box-shadow: 0 0 15px rgba(0,0,0, .05);
		background-color: #fff;
		.topic{
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			margin: 10px 0;
			.num{
				color: #BEBEC2;
				font-weight: 800;
				font-style: italic;
				margin-right: 10px;
				&.top1{
					color: #FE815F;
				}
				&.top2{
					color: #FEBC5F;
				}
				&.top3{
					color: #FEE35F;
				}
			}
			.topic-title{
				color: #525254;
				cursor: pointer;
			}
		}
		.title{
			font-size: 18px;
			font-weight: 800;
			color: #2B2B2B;
			margin-bottom: 15px;
		}
		.tagList{
			margin: 10px 0;
			.tag{
				background-color: #F1F6FD;
				margin-right: 15px;
				padding: 2px 8px;
				border-radius: 3px;
				color: #5989ee;
				font-size: 14px;
				cursor: pointer;
			}
		}
		.qrcode{
			margin: 20px auto;
			width: 80%;
			display: block;
		}
		.tips{
			font-size: 14px;
			color: #525254;
			text-align: center;
		}
		.btn{
			cursor: pointer;
			float: right;
			color: #AAAEB4;
			font-weight: 500;
			font-size: 14px;
			.el-icon-refresh-right{
				font-size: 20px;
				margin-right: 5px;
				vertical-align: bottom;
			}
		}
		.change-btn{
			.el-icon-refresh-right{
				transform:rotate(360deg);
				transition: all .5s;
			}
		}
		
	}
}
</style>